export interface CandidateImageStatus {
    failed: number;
    pending: number;
}

const originalAlternativeText = new WeakMap<HTMLImageElement, string | null>();
const SAFE_RASTER_SOURCE = /^data:image\/(?:png|gif|jpe?g|webp|avif|bmp);base64,/i;

export const inspectCandidateImages = (document: Document): CandidateImageStatus => {
    let failed = 0;
    let pending = 0;
    document.querySelectorAll('img').forEach((image) => {
        if (!SAFE_RASTER_SOURCE.test(image.getAttribute('src') || '')) return;
        if (!image.complete) {
            pending += 1;
        } else if (image.naturalWidth === 0) {
            failed += 1;
            if (!image.getAttribute('alt')?.trim()) {
                if (!originalAlternativeText.has(image)) originalAlternativeText.set(image, image.getAttribute('alt'));
                image.setAttribute('alt', 'Embedded image unavailable');
            }
        } else if (originalAlternativeText.has(image)) {
            const original = originalAlternativeText.get(image);
            if (original === null) image.removeAttribute('alt');
            else image.setAttribute('alt', original);
            originalAlternativeText.delete(image);
        }
    });
    return { failed, pending };
};
